import React from 'react';

const TYPE_ICON_CLS = {
  red: 'text-red-600 bg-red-50 dark:text-red-400 dark:bg-red-500/10',
  green: 'text-green-600 bg-green-50 dark:text-green-400 dark:bg-green-500/10',
  amber: 'text-orange-600 bg-orange-50 dark:text-orange-400 dark:bg-orange-500/10',
  blue: 'text-blue-600 bg-blue-50 dark:text-blue-400 dark:bg-blue-500/10',
  '': 'text-seha-500 bg-blue-50 dark:bg-blue-500/10',
};

// secondaryValue is optional — when provided, the card shows two numbers side by side
// (e.g. "Active Incidents" + "Active Drills") instead of one, each with its own small
// caption above (valueLabel) and total below (valueTotal), and an optional text color
// class (valueColor, e.g. 'text-red-600 dark:text-red-400') so the two numbers read as
// visually distinct at a glance. All existing single-value callers are unaffected since
// these just default to unset. `note` accepts a plain string or JSX (e.g. colored spans).
export default function KpiCard({
  label, value, valueLabel, valueTotal, valueColor,
  secondaryValue, secondaryValueLabel, secondaryValueTotal, secondaryValueColor,
  note, icon: Icon, type = '',
}) {
  const kpiTypeCls = type ? `kpi-${type}` : '';
  return (
    <div className={`kpi-card ${kpiTypeCls} bg-white p-6 rounded-xl border border-neutral-200 shadow-subtle hover:shadow-card transition-shadow dark:bg-ink-900 dark:border-neutral-700`}>
      <div className="flex justify-between items-start">
        <div>
          <p className="kpi-label">{label}</p>
          {secondaryValue !== undefined ? (
            <div className="flex items-start gap-4 mt-1">
              <div>
                {valueLabel && <p className="text-[11px] text-neutral-400 dark:text-neutral-500">{valueLabel}</p>}
                <h3 className={`kpi-value leading-none mt-0.5 ${valueColor || ''}`}>{value}</h3>
                {valueTotal && <p className="text-[11px] text-neutral-400 mt-1 dark:text-neutral-500">{valueTotal}</p>}
              </div>
              <div className="w-px self-stretch bg-neutral-200 dark:bg-neutral-700" />
              <div>
                {secondaryValueLabel && <p className="text-[11px] text-neutral-400 dark:text-neutral-500">{secondaryValueLabel}</p>}
                <h3 className={`kpi-value leading-none mt-0.5 ${secondaryValueColor || ''}`}>{secondaryValue}</h3>
                {secondaryValueTotal && <p className="text-[11px] text-neutral-400 mt-1 dark:text-neutral-500">{secondaryValueTotal}</p>}
              </div>
            </div>
          ) : (
            <h3 className={`kpi-value ${valueColor || ''}`}>{value}</h3>
          )}
        </div>
        {Icon && (
          <div className={`p-2.5 rounded-lg ${TYPE_ICON_CLS[type] || TYPE_ICON_CLS['']}`}>
            <Icon className="w-6 h-6" />
          </div>
        )}
      </div>
      {note && <p className="kpi-note">{note}</p>}
    </div>
  );
}
